import {
  Box,
  Checkbox,
  Grid,
  IconButton,
  Switch,
  TextField,
  Typography,
  styled,
  useMediaQuery,
} from "@mui/material";
import React, { useState } from "react";
import {
  blackColor,
  blackShade159,
  blackShade21,
  blueColor04,
  borderCart,
  copyBtnColor,
  greyColor40,
  greyColor42,
  greyColor47,
  greyColor5,
  greyColor8,
  greyShade25,
  mobilePrimary,
  outOfStockColor,
  tableHeaderColor,
  whiteColor,
  yellowShade01,
  yellowShade02,
} from "../../../configs/styles/muiThemes";
import SelectWithLabel from "../../../components/Input/SelectWithLabel";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import { textThreeLines, textTwoLines } from "../../../utils/styles";
import { toTitleCase } from "../../../utils/validationUtils";
import AllStockVariantCard from "../Cards/AllStockVariantCard";

function AllStockVariantTab({
  index,
  productList,
  onSelectAll,
  selectedRows,
  totalCount,
  ondcEnabled,
  img,
  title,
  originalAmt,
  amt,
  endDate,
  startDate,
  onValueChange,
  isChecked,
  gst,
  gstRates,
  gstCode,
  errors,
  priceOff,
  validityDays,
  availability,
  alertQty,
  avlQty,
  minQty,
  maxQty,
  disabled,
}) {
  const matches = useMediaQuery((theme) => theme.breakpoints.up("md"));
  const [toggleData, settoggleData] = useState(false);
  const handleShowData = (data) => {
    settoggleData(data);
  };
  return (
    <Box display={"flex"} width={"100%"}>
      <Box
        display="flex"
        alignItems="center"
        flexDirection={"column"}
        backgroundColor={whiteColor}
        sx={{ borderBottom: `1px solid ${tableHeaderColor}` }}
        padding={1}
        width={"100%"}
      >
        <Box
          display="flex"
          alignItems={"center"}
          gap={1}
          justifyContent={"space-between"}
        >
          <Box sx={styles.imgContainer}>
            <Box
              component="img"
              src={img}
              height={"40px"}
              maxWidth={"40px !important"}
            />
          </Box>
          <Typography
            fontSize={{ xs: 13, md: 12.5 }}
            color={blackColor}
            fontWeight={{ xs: 600, md: 500 }}
            lineHeight={1.5}
            mb="0px !important"
            sx={{ ...textTwoLines }}
          >
            {title}
          </Typography>
          <Box
            sx={styles.iconContainer()}
            onClick={() => {
              handleShowData((prev) => !prev);
              console.log("hitt");
            }}
            alignItems={"flex-end"}
          >
            {toggleData ? (
              <ExpandMoreIcon
                // sx={styles.icon(matches ? blackColor : "#e83658")}
                sx={styles.icon("#e83658")}
              />
            ) : (
              <ExpandLessIcon
                sx={styles.icon(matches ? blackColor : "#e83658")}
              />
            )}
          </Box>
        </Box>
        <Box display="flex" alignItems="center" gap={1} ml={2.5}>
          <Typography
            fontSize={11}
            color={blackShade21}
            sx={{
              textDecoration: "line-through",
            }}
          >
            ₹ {originalAmt}
          </Typography>

          <Typography fontSize={12} fontWeight={600} color={blueColor04}>
            ₹ {amt}
          </Typography>

          <Box sx={styles.percentageOffTag}>{priceOff} %</Box>

          <Typography fontSize={11.5} fontWeight={400} color={greyColor40}>
            ONDC Enabled :{" "}
            <span
              style={{
                fontSize: 11,
                fontWeight: 600,
                color: ondcEnabled ? copyBtnColor : outOfStockColor,
              }}
            >
              {/* {toTitleCase(ondcEnabled || "No")} */}
              No
            </span>
          </Typography>
        </Box>
      </Box>
    </Box>
  );
}

export default AllStockVariantTab;

const StyledSwitch = styled(Switch)(({ theme }) => ({
  width: 35,
  height: 16,
  padding: 0,
  display: "flex",
  "&:active": {
    "& .MuiSwitch-thumb": {
      width: 15,
    },
    "& .MuiSwitch-switchBase.Mui-checked": {
      transform: "translateX(8px)",
    },
  },
  "& .MuiSwitch-switchBase": {
    padding: 2,
    "&.Mui-checked": {
      transform: "translateX(18px)",
      color: "#fff",
      "& + .MuiSwitch-track": {
        opacity: 1,
        backgroundColor: copyBtnColor,
      },
    },
  },
  "& .MuiSwitch-thumb": {
    boxShadow: "0 2px 4px 0 rgb(0 35 11 / 20%)",
    width: 12,
    height: 12,
    borderRadius: 6,
    transition: theme.transitions.create(["width"], {
      duration: 200,
    }),
  },
  "& .MuiSwitch-track": {
    borderRadius: 16 / 2,
    opacity: 1,
    backgroundColor:
      theme.palette.mode === "dark" ? "rgba(255,255,255,.35)" : outOfStockColor,
    boxSizing: "border-box",
  },
}));

const InputBox = ({ value, onChange, maxLength, disabled }) => {
  return (
    <TextField
      variant="standard"
      value={value}
      sx={styles.input}
      onChange={onChange}
      disabled={disabled}
      InputProps={{
        disableUnderline: true,
        style: {
          color: blackColor,
          fontSize: { md: 14, xs: 11 },
          fontWeight: 500,
        },
      }}
      inputProps={{ maxLength: maxLength }}
      fullWidth
      autoComplete="off"
    />
  );
};

const styles = {
  checkbox: {
    p: 0,
    transform: "scale(0.95)",
    "&.Mui-checked": {
      color: greyColor8,
    },
  },

  input: {
    width: { md: "65%", xs: "100%" },
    fontSize: { md: 14.5, xs: 11 },
    fontWeight: 500,
    borderTop: "none",
    borderBottom: borderCart,
    borderLeft: "none",
    borderRight: "none",
    backgroundColor: whiteColor,
  },

  labelStyles: {
    display: { md: "none", xs: "block" },
    mt: { xs: 0, md: 3 },
    mb: { xs: 0.5, md: 0 },
  },
  iconContainer: (bgColor, hideMobile) => ({
    width: { md: "20px", xs: "20px" },
    height: { md: "20px", xs: "20px" },
    borderRadius: "50%",
    backgroundColor: whiteColor,
    display: { md: "flex", xs: hideMobile ? "none" : "flex" },
    alignItems: "flex-end",
    justifyContent: "center",
  }),
  icon: (color) => ({ fontSize: { md: 30, xs: 26 }, color: color }),
  imgContainer: {
    width: "40px !important",
    height: "40px",
    borderRadius: "6px",
    border: "1px solid #e5e9f0",
    backgroundColor: whiteColor,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  percentageOffTag: {
    fontSize: 10.5,
    fontWeight: 600,
    color: yellowShade01,
    bgcolor: yellowShade02,
    p: "0px 3px",
    borderRadius: "2px",
  },
  backBtn: {
    backgroundColor: "transparent",
    padding: { md: "4px 6px !important", xs: "3px 6px !important" },
    fontSize: "14px",
    color: { xs: mobilePrimary, md: blackShade159 },
    textTransform: "unset",
    textDecoration: "underline",
    border: {
      xs: "1px solid " + mobilePrimary,
      md: "1px solid " + blackShade159,
    },
  },
};
